export default __webpack_public_path__ + "static/media/Macro2_anchor_spacing.c5a0e897.png";